// Landing layout component

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  TemplateRef,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Subject, filter, takeUntil } from 'rxjs';

import { CommonUtility } from '../../../utils/commonUtils';
import { LoginService } from '../../../services/login-service/login.service';
import { ROUTER_CONSTANTS } from '../../../constants/router.constants';

@Component({
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: ['./landing-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgTemplateOutlet],
})
export class LandingLayoutComponent implements OnDestroy {
  @Input() containerTemplate: TemplateRef<any>;
  isLoggedIn: boolean = false;
  isDashboardPage: boolean = false;
  isSymphonyAccount = CommonUtility.isSymphonyAccount();
  ngUnsubscribe = new Subject<void>();

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.isLoggedIn = this.loginService.isLoggedIn;

    // Initialize isDashboardPage based on current URL
    this.setDashboardPageFlag(this.router.url);

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe((event) => {
        this.isLoggedIn = this.loginService.isLoggedIn;
        this.setDashboardPageFlag(event.urlAfterRedirects);
      });
  }

  /**
   * Sets the isDashboardPage flag based on the URL and triggers change detection
   * @param url - The URL to check
   */
  private setDashboardPageFlag(url: string): void {
    this.isDashboardPage = url
      ? url.split('?')[0].includes(ROUTER_CONSTANTS.dashboard)
      : false;
    this.cdr.markForCheck();
  }

  /**
   * ngOnDestroy lifecycle hook
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
